/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-01-11 14:21:40
 *
 *******************************************************/
// @flow
import _ from 'lodash';
import React, { Component } from 'react';
import { FormLayout, Link, TextStyle } from '@shopify/polaris';
import { Field } from 'redux-form';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { RenderToggleSwitch } from 'src/components/views/common/forms/render-toggle-switch';
import { RenderRadioButton2 } from 'src/components/views/common/forms/render-radio-button-2';
import { PRODUCT_IMAGE_THUMBNAIL_OPTIONS } from 'src/constants/theme-settings';
import { MENU_ID } from 'src/constants/theme-settings.jsx';
import { URL } from 'src/constants/links';

type Props = {
  formValues: any,
  updateField: (field: string, value: any) => void
};

type ComposedProps = Props & WithI18nProps;

class QuickViewForm extends Component<ComposedProps> {
  state = {};

  render() {
    const { i18n, formValues } = this.props;

    return (
      <FormLayout>
        <div className="form-section">
          <TextStyle variation="subdued">
            {i18n.translate('AdminHTML.ThemeSetting.Form.quickView_HelpText_Label', {
              t1: (
                <Link external url={URL['EnableQuickViewDoc']}>
                  {i18n.translate('AdminHTML.ThemeSetting.Form.quickView_HelpText_t1')}
                </Link>
              )
            })}
          </TextStyle>

          {/* PRODUCT IMAGE */}
          <div className="form-section__item" style={{ marginTop: '22px' }}>
            <p className="title" style={{ fontWeight: 600, marginBottom: '18px' }}>
              {i18n.translate('AdminHTML.ThemeSetting.Setting.productItem_ProductImage')}
            </p>
            <Field
              name={`setting.${MENU_ID.QUICK_VIEW}.showProductImage`}
              component={RenderToggleSwitch}
              label={i18n.translate(
                'AdminHTML.ThemeSetting.Form.quickView_ProductImage_Toggle_Label'
              )}
            />
          </div>

          {_.get(formValues, `setting.${MENU_ID.QUICK_VIEW}.showProductImage`) && (
            <>
              <div className="form-section__item form-section__item--medium-spacing">
                <p>
                  {i18n.translate(
                    'AdminHTML.ThemeSetting.Form.quickView_ProductImage_Thumbnail_Title'
                  )}
                </p>
              </div>
              <div className="form-section__item form-section__item--small-spacing">
                <div className="radio-button-wrapper radio-button-wrapper--no-gap radio-button-wrapper--bordered">
                  {PRODUCT_IMAGE_THUMBNAIL_OPTIONS.map((item, index) => (
                    <Field
                      key={index}
                      name={`setting.${MENU_ID.QUICK_VIEW}.thumbnailPosition`}
                      id={item.value}
                      component={RenderRadioButton2}
                      label={i18n.translate(item.label)}
                      defaultValue="top-left"
                    />
                  ))}
                </div>
              </div>
              <div className="form-section__item form-section__item--small-spacing">
                <TextStyle variation="subdued">
                  {i18n.translate(
                    'AdminHTML.ThemeSetting.Form.quickView_ProductImage_HelpText_Label'
                  )}
                </TextStyle>
              </div>
            </>
          )}

          {/* BUY IT NOW BUTTON */}
          <div className="form-section__item form-section__item--standard-spacing form-section__item--bordered-top">
            <p className="title" style={{ fontWeight: 600, marginBottom: '18px' }}>
              {i18n.translate('AdminHTML.ShopifyIntegrationSettings.Form.quickView_BuyNow_Title')}
            </p>

            <TextStyle variation="subdued">
              {i18n.translate('AdminHTML.ThemeSetting.Form.quickView_BuyNow_HelpText_Label')}
            </TextStyle>
            <div className="form-section__item form-section__item--medium-spacing">
              <Field
                name={`setting.${MENU_ID.QUICK_VIEW}.buyItNowBtn.enable`}
                component={RenderToggleSwitch}
                label={i18n.translate('AdminHTML.ThemeSetting.Form.quickView_BuyNow_Toggle_Label')}
              />
            </div>
          </div>
        </div>
      </FormLayout>
    );
  }
}

export default withI18n()(QuickViewForm);
